import React from 'react';
import PropTypes from 'prop-types';
import dateFormat from 'dateformat';

import { getStaticImageUrl } from 'client/utils/image-helpers';
import { NO_VEHICLE_GRAY_IMAGE_SEDAN } from 'client/site-modules/shared/constants/images';
import { Link } from 'site-modules/shared/components/link/link';
import { CardRemoveButton } from 'site-modules/profile/components/shared/card-remove-button/card-remove-button';

import './sold-card.scss';

export function SoldCard({ vinData, submittedTs = null, isSubmittedLead = false, removeCard }) {
  const { niceMake, niceModel, year, vin } = vinData;

  const noVehicleImage = getStaticImageUrl(NO_VEHICLE_GRAY_IMAGE_SEDAN);
  const findSimilarURL = `/inventory/srp.html?make=${niceMake}&model=${niceModel}&year=${year}`;
  const vehicleName = `${year} ${niceMake} ${niceModel}`;
  const ariaDescribedBy = `desc-${vin}`;

  return (
    <div className="d-flex flex-column sold-card pos-r">
      <div
        className="photo-wrapper d-flex flex-column pos-r bg-gray-extra-light w-100 rounded-top"
        id={ariaDescribedBy}
      >
        <div
          className="no-vehicle-img w-100 mt-0_75"
          style={{ backgroundImage: `url(${noVehicleImage})`, backgroundSize: 'cover' }}
        />
        {isSubmittedLead && (
          <div className="pos-a left-0 top-0 z-index-1 text-info pt-0_5 ps-0_5 medium">
            Dealer contacted {dateFormat(submittedTs, 'mm/dd/yy')}
          </div>
        )}
        <div className="car-not-available-message text-center px-2 text-gray-darker fw-medium">
          This car is no longer available
        </div>
      </div>
      <div className="vehicle-card-body p-1 size-16">
        <div className="inventory-make text-capitalize text-gray-darker pb-1_5">{vehicleName}</div>
        <Link to={findSimilarURL} data-tracking-id="find_more_cars_like_this" className="text-primary-darker">
          Find similar cars <span className="icon-arrow-right3 size-10" aria-hidden />
          <span className="visually-hidden">{vehicleName}</span>
        </Link>
      </div>
      <CardRemoveButton
        onClick={removeCard}
        className="p-0_25 me-0_5 mt-0_5"
        ariaLabel={vehicleName}
        ariaDescribedBy={ariaDescribedBy}
      />
    </div>
  );
}

SoldCard.propTypes = {
  removeCard: PropTypes.func.isRequired,
  vinData: PropTypes.shape({
    niceMake: PropTypes.string.isRequired,
    niceModel: PropTypes.string.isRequired,
    year: PropTypes.number.isRequired,
  }).isRequired,
  submittedTs: PropTypes.string,
  isSubmittedLead: PropTypes.bool,
};
